"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sentry = void 0;
const browser_1 = require("@sentry/browser");
const browser_2 = require("@sentry/browser");
const integrations_1 = require("@sentry/integrations");
const config_1 = require("./config");
const captureError = (error) => {
    (0, browser_1.captureException)(error);
};
const setTag = (tag, value) => {
    (0, browser_1.setTag)(tag, value);
};
const initSentry = async (config) => {
    const integrations = [
        new browser_2.ModuleMetadata(),
        new integrations_1.HttpClient(),
        new browser_1.BrowserTracing()
    ];
    if (config.enableReplay) {
        const { Replay } = await Promise.resolve().then(() => __importStar(require('@sentry/browser')));
        integrations.push(new Replay({
            blockAllMedia: false,
            // Blocked for privacy reasons
            maskAllText: true,
            maskAllInputs: true,
            // See performance issues with grids https://github.com/getsentry/sentry-javascript/issues/8469
            mutationBreadcrumbLimit: 750,
            mutationLimit: 750
        }));
    }
    (0, browser_1.init)({
        ...config,
        tracesSampleRate: config.environment === 'prod' ? 0.05 : 0,
        ...config_1.baseConfig
    });
};
exports.Sentry = {
    init: initSentry,
    captureError,
    setTag
};
//# sourceMappingURL=index.js.map